import React from "react";

function formatIndicatorValue(indicator) {
  if (
    indicator?.value === null ||
    indicator?.value === undefined
  ) {
    return "—";
  }

  return `${indicator.value}${indicator.unit || ""}`;
}

export default function TBIndicators({ indicators }) {
  if (!Array.isArray(indicators) || indicators.length === 0) {
    return (
      <div className="tb-indicators-empty">
        No framework indicator data available.
      </div>
    );
  }

  return (
    <div className="tb-indicators-panel">
      <div className="tb-indicators-grid">
        {indicators.map((indicator, index) => (
          <article
            key={indicator.key || index}
            className="tb-indicator-card"
          >
            <div className="tb-indicator-top">
              <span className="tb-indicator-number">
                Indicator {String(index + 1).padStart(2, "0")}
              </span>

              <strong className="tb-indicator-value">
                {formatIndicatorValue(indicator)}
              </strong>
            </div>

            <h3>{indicator.label}</h3>

            {indicator.detail && (
              <p>{indicator.detail}</p>
            )}
          </article>
        ))}
      </div>
    </div>
  );
}